// extracted by mini-css-extract-plugin
export var cardContainer = "_pp-0";
export var cardHeader = "_pp-2";
export var collapsedState = "_pp-3";
export var dragHandle = "_pp-5";
export var dragHandleIcon = "_pp-6";
export var dragging = "_pp-1";
export var titleArea = "_pp-4";